import { FunctionComponent } from "react";

import {
  TRANSCRIPT_FAILED_STATUSES,
  TRANSCRIPT_IN_PROGRESS_STATUSES,
  TRANSCRIPT_SUCCESS_STATUSES,
  type TranscriptStatus as TranscriptStatusType,
} from "@/constants";
import { useMentionCard } from "@/containers/MentionCard/context";
import { cx } from "@/utils";
import Highlight from "@components/Highlight";

import styles from "./TranscriptStatus.module.css";

const isInProgress = (status: TranscriptStatusType) =>
  (TRANSCRIPT_IN_PROGRESS_STATUSES as readonly TranscriptStatusType[]).includes(
    status
  );

const isSuccess = (status: TranscriptStatusType) =>
  (TRANSCRIPT_SUCCESS_STATUSES as readonly TranscriptStatusType[]).includes(
    status
  );

const isFailed = (status: TranscriptStatusType) =>
  (TRANSCRIPT_FAILED_STATUSES as readonly TranscriptStatusType[]).includes(
    status
  );

const TranscriptStatus: FunctionComponent<{ className?: string }> = ({
  className,
}) => {
  const {
    episode: { has_transcript, transcript_status },
  } = useMentionCard();

  let label = null;

  if (has_transcript) {
    if (transcript_status && isInProgress(transcript_status)) {
      label = L.TRANSCRIPTION_STATUS_QUEUED;
    } else if (transcript_status && isSuccess(transcript_status)) {
      label = null;
    } else if (transcript_status && isFailed(transcript_status)) {
      label = L.TRANSCRIPTION_STATUS_FAILED;
    } else {
      label = L.TRANSCRIPTION_STATUS_ONGOING;
    }
    // don't show if has_transcript is undefined
  } else if (has_transcript === false) {
    label = L.TRANSCRIPTION_STATUS_NOT_TRANSCRIBED;
  }

  return label ? (
    <Highlight
      className={cx(styles.root, className, {
        [styles.hasError]: !!transcript_status && isFailed(transcript_status),
      })}
      label={label}
    />
  ) : null;
};

export default TranscriptStatus;
